module.exports = __webpack_public_path__ + "static/img/icon-right.5fba0311.svg";